// extracted by mini-css-extract-plugin
module.exports = {"vanlife-L-smart":"Smart_vanlife-L-smart__JISnt"};